const SummaryEn = () => {
    return (
			<div>
				<h6>About me:</h6>
				<p>
					From 2010 until I graduated in 2012, I worked as a part-time student in my own department at my university. I have been
					in software development activities since I won Erzincan University in 2010. I graduated from Anadolu University Faculty of Business Administration in 2014.
				</p>
				<p>
					I founded and managed Gazi Software company between 2017-2018, worked as a software specialist in the development of
					corporate erp-crm-hrm software of Beyoğlu Kaza Danışmanlık from August 2017 to September 2019.
				</p>
				<p>
					<strong>I know php, mysql, sqlite on mobile, html, css, javascript, jquery, react and react-native, redux, java and spring
					framework at expert level. I developing software with restful and software design patterns.</strong> My linkedin for the projects I've worked on and details following:
				</p>
			</div>
		)
}

export default SummaryEn
